import { rarityPips, itemDef, mandingaPrice, MASCATE_ITEM, MASCATE_NAMES, SIMPATIA_BY_ID, SIMPATIA_RARITY_NAMES, structureName, type MascateSpecialty } from "@eldrun/content";

/** O que o cliente lê do schema `Mascate`. */
export interface MascateLike {
  specialty: string;
  closed: boolean;
  sells: Iterable<OfferLike>;
  buys: Iterable<OfferLike>;
}

export interface OfferLike {
  item: string;
  qty: number;
  price: number;
  stock: number;
}

export interface TradeRow {
  key: string;
  side: "comprar" | "vender";
  index: number;
  item: string;
  text: string;
  price: number;
  stock: number;
  /** Motivo de não dar (o servidor confere de novo), ou `undefined`. */
  blocked: string | undefined;
}

const name = (id: string) => itemDef(id)?.name ?? id;

/**
 * Linhas do painel do mascate: o que ele vende (o jogador compra, com o saldo) e o que ele compra
 * (o jogador vende, com o que tem). A prévia só desliga o botão; quem decide é o servidor.
 */
export function tradeRows(m: MascateLike, coins: number, owned: (itemId: string) => number, mandinga = ""): TradeRow[] {
  const rows: TradeRow[] = [];
  [...m.sells].forEach((o, index) => {
    // Feira Livre: o desconto já aparece no painel (o servidor cobra o mesmo cálculo).
    const price = mandingaPrice(o.price, mandinga, "comprar");
    rows.push({
      key: `comprar:${index}`,
      side: "comprar",
      index,
      item: o.item,
      text: `${o.qty}× ${name(o.item)}`,
      price,
      stock: o.stock,
      blocked: m.closed ? "fechado" : o.stock <= 0 ? "sem estoque" : coins < price ? "sem moedas" : undefined,
    });
  });
  [...m.buys].forEach((o, index) =>
    rows.push({
      key: `vender:${index}`,
      side: "vender",
      index,
      item: o.item,
      text: `${o.qty}× ${name(o.item)}`,
      price: o.price,
      stock: o.stock,
      blocked: m.closed ? "fechado" : o.stock <= 0 ? "não compra mais" : owned(o.item) < o.qty ? `você tem ${owned(o.item)}` : undefined,
    }),
  );
  return rows;
}

export const mascateName = (specialty: string): string => MASCATE_NAMES[specialty as MascateSpecialty] ?? structureName(MASCATE_ITEM);

/** Texto da Simpatia ganha (toast). */
export function simpatiaText(simpatia: string, who: string | undefined): string {
  const def = SIMPATIA_BY_ID.get(simpatia);
  const label = def ? `${def.name} (${SIMPATIA_RARITY_NAMES[def.rarity]})` : simpatia;
  return who ? `${who} ganhou ${label}.` : `Você ganhou ${label}!`;
}

/** Simpatias do jogador para o HUD: nome, pilhas e o efeito somado. */
export function simpatiaChips(counts: Iterable<[string, number]>): { id: string; text: string; title: string; rarity: string }[] {
  const out: { id: string; text: string; title: string; rarity: string }[] = [];
  for (const [id, n] of counts) {
    const def = SIMPATIA_BY_ID.get(id);
    if (!def || n <= 0) continue;
    // Raridade sem cor (F60): ◆ Comum, ◆◆ Rara, ◆◆◆ Lendária, antes do nome.
    out.push({ id, text: `${rarityPips(def.rarity)} ${n > 1 ? `${def.name} ×${n}` : def.name}`, title: def.describe(n), rarity: def.rarity });
  }
  return out.sort((a, b) => (a.id < b.id ? -1 : 1));
}
